import { service, baseURL, service2 } from './index';

// 登录
export function loginApi(data) {
	return service({
		url: '/nkyxf/login',
		method: 'post',
		data: data,
	});
}
// 获取字典表数据
export function getDicts(dictName) {
	return service({
		url: `/nkyxf/dict/dict-items/${dictName}`,
		method: 'GET',
	});
}
// 获取字典表数据
export function getCmsDicts(data) {
	return service({
		url: `/nkyxf/dict/all-dicts`,
		method: 'GET',
		data: data,
	});
}
// 获取菜单
export function NavApi(data) {
	return service({
		url: '/nkyxf/web-data/menu-list',
		method: 'post',
		data: data,
	});
}

// 获取文章列表
export function articleListApi(data) {
	return service({
		url: '/nkyxf/web-data/articel-page',
		method: 'post',
		data: data,
	});
}

// 获取文章信息
export function articleApi(id) {
	return service({
		url: `/nkyxf/web-data/get-article-by-id/${id}`,
		method: 'get',
	});
}

// 会员信息列表
export function memberListApi(data) {
	return service({
		url: '/nkyxf/web-data/member-list',
		method: 'post',
		data: data,
	});
}

// 会员展示信息
export function memberApi(memberId) {
	return service({
		url: `/nkyxf/web-data/member-show-info/${memberId}`,
		method: 'get',
	});
}

// 图片展示
export function imgApi(id) {
	return service({
		url: `/nkyxf/web-data/show-img/${id}`,
		method: 'get',
		responseType: 'blob',
	});
}

// 图片展示
export function imgSApi(id) {
	let url = `${baseURL}/nkyxf/web-data/show-img/${id}`;
	return url;
}

// 保存培训服务报名表
export function trainingServiceSaveApi(url, data) {
	return service2({
		url: `/nkyxf/px-training-t/${url}`,
		method: 'post',
		data: data,
	});
}
// 所有供需对接信息列表
export function gxdjListApi() {
	return service({
		url: '/nkyxf/web-data/gxdj-list',
		method: 'post',
		data: {},
	});
}
// 所有提供服务信息列表
export function tgfwListApi() {
	return service({
		url: '/nkyxf/web-data/tgfw-list',
		method: 'post',
		data: {},
	});
}
